import {
  getFinalCelsiusConversion,
  getFinalFahrenheitConversion,
  getFinalDelisleConversion,
  getFinalKelvinConversion,
  getFinalNewtonConversion,
  getFinalRankineConversion,
  getFinalReamurConversion,
  getFinalRomerConversion
} from "./TempConversionTracker";

function getConversion(val, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "ce":
      result = getFinalCelsiusConversion(val, conType);
      break;
    case "fa":
      result = getFinalFahrenheitConversion(val, conType);
      break;
    case "ne":
      result = getFinalNewtonConversion(val, conType);
      break;
    case "de":
      result = getFinalDelisleConversion(val, conType);
      break;
    case "re":
      result = getFinalReamurConversion(val, conType);
      break;
    case "ro":
      result = getFinalRomerConversion(val, conType);
      break;
    case "ke":
      result = getFinalKelvinConversion(val, conType);
      break;
    case "ra":
      result = getFinalRankineConversion(val, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
